import * as React from 'react';

const MOBILE_BREAKPOINT = 768;

/**
 * When true, {@link useIsMobile} always reports desktop. Used by the app
 * navigation sidebar so a narrow browser window keeps the collapsible rail
 * instead of switching to the Sheet path (which has no external trigger).
 * Real phones never reach this code — the VD router sends them to MobileLanding.
 */
const ForceDesktopSidebarContext = React.createContext(false);

export function ForceDesktopSidebar({ children }: { children: React.ReactNode }) {
  return React.createElement(ForceDesktopSidebarContext.Provider, { value: true }, children);
}

export function useIsMobile() {
  const forceDesktop = React.useContext(ForceDesktopSidebarContext);
  const [isMobile, setIsMobile] = React.useState<boolean | undefined>(undefined);

  React.useEffect(() => {
    if (forceDesktop) return;
    const mql = window.matchMedia(`(max-width: ${MOBILE_BREAKPOINT - 1}px)`);
    const onChange = () => {
      setIsMobile(window.innerWidth < MOBILE_BREAKPOINT);
    };
    mql.addEventListener('change', onChange);
    setIsMobile(window.innerWidth < MOBILE_BREAKPOINT);
    return () => mql.removeEventListener('change', onChange);
  }, [forceDesktop]);

  if (forceDesktop) return false;
  return !!isMobile;
}
